"use client";

import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { type SupportedLanguage } from "@/lib/shared";
import { localizedPath } from "@/lib/localePath";
import { resolveLocale } from "@/lib/resolvedLocale";

/**
 * Shown for paths under /:locale that are not wired in the SPA router yet
 * (e.g. /en/following). Avoids React Router’s default 404 screen.
 */
export default function LocaleCatchAllPage() {
  const params = useParams();
  const locale: SupportedLanguage = resolveLocale(
    params.locale as string | undefined,
  );
  const rest = params["*"]?.trim() ?? "";

  return (
    <div className="flex min-h-[calc(100vh-65px)] flex-col items-center justify-center gap-4 px-6 text-center lg:min-h-[calc(100vh-104px)]">
      <div className="space-y-2 max-w-md">
        <h1 className="text-xl font-semibold text-foreground">
          هذه الصفحة غير متوفرة في نسخة الويب الحالية
        </h1>
        <p className="text-sm text-muted-foreground">
          This screen is not implemented in the current SPA build.
          {rest ? (
            <span className="block mt-2 font-mono text-xs opacity-80">
              /{rest}
            </span>
          ) : null}
        </p>
      </div>
      <Button asChild variant="default">
        <Link to={localizedPath(locale, "/")}>العودة للرئيسية / Back home</Link>
      </Button>
    </div>
  );
}
